var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage80({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.625 17.5H4.375a.625.625 0 0 1-.625-.625V3.125a.625.625 0 0 1 .625-.625h7.5l4.375 4.375v10a.624.624 0 0 1-.625.625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.875 2.5v4.375h4.375m-8.75 3.75h5m-5 2.5h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage80);
export default __webpack_public_path__ + "static/media/image80.457e8e33f3d0dbee073a641c7f51f71b.svg";
export { ForwardRef as ReactComponent };